<template>
  <div class="rt-view-wrapper">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RtView'
};
</script>



// WEBPACK FOOTER //
// rtView.vue?d334d27e